import { TranslationEntity } from 'src/common';

export class RoleModel {
  id: number;
  name: string;
  description: string;
  selected: boolean;
  translationName: TranslationEntity;
}

export class RoleDetailsModel {
  id: number;
  name: string;
  description: string;
  translationName: TranslationEntity;
  createdByName: string;
  createdOn?: Date;
  updatedByName: string;
  updatedOn?: Date;
  selected: boolean;
}

export class RoleSaveModel {
  id: number;
  name: string;
  description: string;
  translationName: TranslationEntity;
}
